"use strict";
/* tslint:disable:max-line-length */
Object.defineProperty(exports, "__esModule", { value: true });
var service_definition_1 = require("./../services/service-definition");
var messaging_client_forward_send_request_serialiser_1 = require("./../services/control/messaging-client-forward-send-request-serialiser");
var messaging_client_send_request_serialiser_1 = require("./../services/control/messaging-client-send-request-serialiser");
var messaging_filter_response_serialiser_1 = require("./../services/control/messaging-filter-response-serialiser");
var messaging_filter_send_request_serialiser_1 = require("./../services/control/messaging-filter-send-request-serialiser");
var messaging_filter_send_response_serialiser_1 = require("./../services/control/messaging-filter-send-response-serialiser");
var messaging_response_serialiser_1 = require("./../services/control/messaging-response-serialiser");
var messaging_send_request_serialiser_1 = require("./../services/control/messaging-send-request-serialiser");
exports.MESSAGING_SEND = {
    id: 85,
    request: messaging_send_request_serialiser_1.MessagingSendRequestSerialiser,
    response: messaging_response_serialiser_1.MessagingResponseSerialiser
};
exports.MESSAGING_RECEIVER_SERVER = {
    id: 86,
    request: messaging_client_send_request_serialiser_1.MessagingClientSendRequestSerialiser,
    response: messaging_response_serialiser_1.MessagingResponseSerialiser
};
exports.MESSAGING_RECEIVER_CLIENT = {
    id: 88,
    request: messaging_client_forward_send_request_serialiser_1.MessagingClientForwardSendRequestSerialiser,
    response: messaging_response_serialiser_1.MessagingResponseSerialiser
};
exports.MESSAGING_FILTER_SEND = {
    id: 102,
    request: messaging_filter_send_request_serialiser_1.MessagingFilterSendRequestSerialiser,
    response: messaging_filter_send_response_serialiser_1.MessagingFilterSendResponseSerialiser
};
exports.FILTER_RESPONSE = {
    id: 103,
    request: messaging_filter_response_serialiser_1.MessagingFilterResponseSerialiser,
    response: service_definition_1.NullSerialiser
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/messages-services.js
// module id = 1336
// module chunks = 1